export default __webpack_public_path__ + "static/media/logo.a5d1aa5f.jpg";